const SCRIPT_ID = 'google-maps-script'

const readApiKey = () =>
  document
    .querySelector('meta[name="google-maps-api-key"]')
    ?.getAttribute('content') ?? ''

// Injected on demand the first time a Maps surface (map, places autocomplete,
// or home search) is used, so plain pageviews don't download the SDK. Idempotent.
export const loadGoogleMapsScript = (): void => {
  // SSR stubs `document` (helpers/isomorphic.js) with only a couple of methods,
  // so guard on the specific DOM APIs we use rather than document's existence.
  if (
    typeof document === 'undefined' ||
    typeof document.getElementById !== 'function' ||
    typeof document.createElement !== 'function' ||
    !document.body
  ) {
    return
  }

  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.src =
    `https://maps.googleapis.com/maps/api/js?key=${readApiKey()}` +
    '&libraries=places&loading=async'

  document.body.appendChild(script)
}
